import React from "react";
import {
    Box,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Table
} from '@material-ui/core';

export default class ComponentToPrint extends React.Component {
    render() {
        const AmendmentAuditSearchData = this.props.AmendmentAuditSearchData;
        const amendmentAuditReportData = this.props.amendmentAuditReportData;

        return (
            <div>
                <h2><center>Amendment Audit Report</center></h2>
                <h3><center>Group : {AmendmentAuditSearchData.groupName} - Factory : {AmendmentAuditSearchData.factoryName}</center></h3>
                <h3><center>Route : {AmendmentAuditSearchData.routeName ? AmendmentAuditSearchData.routeName : 'All Routes'}</center></h3>
                <h3><center>{AmendmentAuditSearchData.month} - {AmendmentAuditSearchData.year}</center></h3>
                <div>&nbsp;</div>
                <div>&nbsp;</div>
                <div>
                    <Box minWidth={1050}>
                        <TableContainer >
                            <Table aria-label="caption table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align={'center'}>Entry No</TableCell>
                                        <TableCell align={'center'}>Collection Type</TableCell>
                                        <TableCell align={'center'}>Collected Date</TableCell>
                                        <TableCell align={'center'}>Type of change</TableCell>
                                        <TableCell align={'center'}>Amended By</TableCell>
                                        <TableCell align={'center'}>Amended Date</TableCell>
                                        <TableCell align={'right'}>Original Weight</TableCell>
                                        <TableCell align={'right'}>Amended Weight</TableCell>
                                        <TableCell align={'right'}>Deference</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {amendmentAuditReportData.map((data, index) => (
                                        <TableRow key={index}>
                                            <TableCell align={'center'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                                {data.entryNo}
                                            </TableCell>
                                            <TableCell align={'center'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                                {data.collectionType}
                                            </TableCell>
                                            <TableCell align={'center'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                                {data.collectedDate.split('T')[0]}
                                            </TableCell>
                                            <TableCell align={'center'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                                {data.typeOfChange == true ? 'Modified' : 'Deleted'}
                                            </TableCell>
                                            <TableCell align={'center'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                                {data.amendedBy}
                                            </TableCell>
                                            <TableCell align={'center'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                                {data.amendedDate.split('T')[0]}
                                            </TableCell>
                                            <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                                {data.typeOfChange == true || data.originalNetWeight != 0 ?  data.originalNetWeight.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : data.amendedWeight.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                            </TableCell>
                                            <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                                {data.typeOfChange == true || data.originalNetWeight != 0 ? data.amendedWeight.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : data.originalNetWeight.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                            </TableCell>
                                            <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                                {data.deference > 0 ? data.deference.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : (Math.abs( data.deference)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </div>
                <div>&nbsp;</div>
                <h3><center>***** End of List *****</center></h3>
            </div>
        );

    }

}